import React, { useEffect, useState } from "react";
import {
  GetRequest,
  PostRequest,
  PutRequest,
  DeleteRequest,
} from "../../repository/RequestMaker";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashCan, faEdit } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import "./Companies.css";

Modal.setAppElement("#root");

export default function Plans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    price: "",
  });

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = () => {
    setLoading(true);
    GetRequest("/plans")
      .then((response) => {
        setPlans(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch plans", error);
        setLoading(false);
      });
  };

  const formatDate = (dateString) => {
    return moment(dateString).format("YYYY-MM-DD HH:mm:ss");
  };

  const openModal = (plan = null) => {
    if (plan) {
      setFormData({
        id: plan.id,
        name: plan.name,
        price: plan.price,
      });
      setIsEditMode(true);
    } else {
      setFormData({
        id: "",
        name: "",
        price: "",
      });
      setIsEditMode(false);
    }
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const onDeleteClick = (id) => {
    setDeleteId(id);
    setDeleteModalIsOpen(true);
  };

  const handleDelete = () => {
    DeleteRequest(`/plans/${deleteId}`)
      .then(() => {
        fetchPlans();
        closeDeleteModal();
      })
      .catch((error) => {
        console.error("Failed to delete plan", error);
        closeDeleteModal();
      });
  };

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
    setDeleteId(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log(`Changing ${name} to ${value}`);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const request = isEditMode
      ? PutRequest(formData, `/plans/${formData.id}`)
      : PostRequest(formData, "/plans");

    request
      .then(() => {
        fetchPlans();
        closeModal();
      })
      .catch((error) => {
        console.error("Failed to submit form", error);
      });
  };

  return (
    <div className="companies-container">
      <div className="actions-header">
        <button className="btn-add" onClick={() => openModal()}>
          <FontAwesomeIcon icon={faPlus} /> Add New plan
        </button>
      </div>
      {loading ? (
        <p style={{ textAlign: "center" }}>Wird geladen...</p>
      ) : (
        <div className="card-admin animated fadeInDown">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Price</th>
                <th>Erstellungsdatum</th>
                <th>Bearbeitungsdatum</th>
                <th>Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {plans.map((plan) => (
                <tr key={plan.id}>
                  <td>{plan.id}</td>
                  <td>{plan.name}</td>
                  <td>{`${parseFloat(plan.price).toFixed(2)}`} €</td>
                  <td>{formatDate(plan.created_at)}</td>
                  <td>{formatDate(plan.updated_at)}</td>
                  <td>
                    <button
                      className="btn-edit"
                      onClick={() => openModal(plan)}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    &nbsp;
                    <button
                      className="btn-delete"
                      onClick={() => onDeleteClick(plan.id)}
                    >
                      <FontAwesomeIcon icon={faTrashCan} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={{
          overlay: {
            zIndex: 9999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            maxHeight: "80%",
            overflow: "auto",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <h5>{isEditMode ? "Update Plan" : "Add New Plan"}</h5>
        <form onSubmit={handleFormSubmit} className="modal-form">
          <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              name="slug"
              value={formData.name}
              onChange={handleInputChange}
              required
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label>Price:</label>
            <input
              type="integer"
              name="price"
              value={formData.price}
              onChange={handleInputChange}
              required
              className="form-control"
            />
          </div>
          <div style={{ paddingTop: "15px" }} className="modal-actions">
            <button type="submit" className="btn-submit">
              {isEditMode ? "Update" : "Add"}
            </button>
            <button type="button" className="btn-cancel" onClick={closeModal}>
              Cancel
            </button>
          </div>
        </form>
      </Modal>
      <Modal
        isOpen={deleteModalIsOpen}
        onRequestClose={closeDeleteModal}
        style={{
          overlay: {
            zIndex: 9999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            maxHeight: "80%",
            overflow: "auto",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <h5>Are you sure you want to delete this plan?</h5>
        <div className="modal-actions">
          <button className="btn-delete" onClick={handleDelete}>
            Delete
          </button>
          <button className="btn-cancel" onClick={closeDeleteModal}>
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  );
}
